import Box, { BoxProps } from "@mui/material/Box";
import * as React from "react";

export interface AccountPopoverFooterProps extends BoxProps {
  children?: React.ReactNode;
}

function AccountPopoverFooter(props: AccountPopoverFooterProps) {
  const { children, ...rest } = props;
  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        flexDirection: "row",
        p: 1,
        justifyContent: "flex-end",
        ...rest.sx,
      }}
    >
      {children}
    </Box>
  );
}

export { AccountPopoverFooter };
